import { render } from "./personalData.vue?vue&type=template&id=16862c78&ts=true"
import script from "./personalData.vue?vue&type=script&lang=ts"
export * from "./personalData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__